if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) return;

        this.handleErrorMessage();
        this.cartNotification.setActiveElement(null);

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.append(
          "sections",
          this.cartNotification.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }
            this.cartNotification.renderContents(response);
            // if on the cart page, we should rerender the cart section
            if (window.location.pathname === window.routes.cart_url) {
              // Reload just the main cart content that actually changed
              const mainCartSection = document.getElementById("main-cart");
              if (mainCartSection && mainCartSection.dataset.id) {
                fetch(`/?section_id=${mainCartSection.dataset.id}&t=${Date.now()}`)
                  .then((response) => response.text())
                  .then((html) => {
                    const parser = new DOMParser();
                    const newDoc = parser.parseFromString(html, "text/html");

                    // Only update the cart contents without affecting other elements like notifications
                    const newCartTable = newDoc.querySelector(".js-contents");
                    const currentCartTable = document.querySelector(".js-contents");

                    if (newCartTable && currentCartTable) {
                      currentCartTable.innerHTML = newCartTable.innerHTML;

                      // Update cart container classes to show content properly
                      const cartContainer = document.querySelector(".main-cart");
                      if (cartContainer) {
                        cartContainer.classList.remove("is-empty");
                      }

                      const cartItemsContainer = document.querySelector("cart-items");
                      if (cartItemsContainer && cartItemsContainer.parentElement) {
                        cartItemsContainer.parentElement.classList.remove("is-empty");
                      }
                    }

                    // Also update the cart footer if present
                    const newCartFooter = newDoc.querySelector(".js-contents-footer");
                    const currentCartFooter = document.querySelector(".js-contents-footer");

                    if (newCartFooter && currentCartFooter) {
                      currentCartFooter.innerHTML = newCartFooter.innerHTML;
                    }

                    // Update free shipping threshold if present
                    const newFreeShippingBar = newDoc.querySelector(".js-contents-footer-free-shipping-bar");
                    const currentFreeShippingBar = document.querySelector(".js-contents-footer-free-shipping-bar");

                    if (newFreeShippingBar && currentFreeShippingBar) {
                      currentFreeShippingBar.innerHTML = newFreeShippingBar.innerHTML;
                    }

                    // Update cart footer container classes
                    const cartFooter = document.getElementById("main-cart-footer");
                    if (cartFooter) {
                      cartFooter.classList.remove("is-empty");
                    }
                  })
                  .catch((e) => {
                    console.error("Fetch error:", e);
                  });
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
